import { defaultTo } from 'ramda';
import { IWriteOffInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/WriteOffInfoSchema';
import { ICheckoutDetail } from '../../../types/reducers/checkoutInfo';

export function mapDetails(writeOffInfo?: IWriteOffInfoSchema | null): Array<ICheckoutDetail> {
  const parts = writeOffInfo?.parts || [];

  return parts.map(({ priceDescription, priceNote, description, discountAmount, discountDescription = null }) => ({
    name: description,
    priceDescription,
    priceNote,
    discountDescription,
    discount: defaultTo(0, discountAmount),
  }));
}
